var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { DateField } from '@doordash/component-fields';
import { InlineChildren } from '@doordash/design-language';
import * as React from 'react';
import { BUDGET_REFRESH_INTERVAL } from '../budget_helper';
import { isDateBefore, isEndOfDayBeforeNow, isValidTimeFormat, } from '../../../../utils/format_time';
import { InputContainer } from './budget_form_styles';
export var BudgetDatesSelector = function (_a) {
    var values = _a.values, errors = _a.errors, handleChange = _a.handleChange, setFieldValue = _a.setFieldValue, disableStartDate = _a.disableStartDate;
    var _b = __read(React.useState(''), 2), hasActiveDateError = _b[0], setHasActiveDateError = _b[1];
    var _c = __read(React.useState(''), 2), hasInactiveDateError = _c[0], setHasInactiveDateError = _c[1];
    var isValidDate = function (valuesField, setError, date, validateDateOrder // start date
    ) {
        if (!isValidTimeFormat(date, 'MM/DD/YYYY') && Boolean(date === null || date === void 0 ? void 0 : date.length)) {
            setError('Invalid date format');
        }
        else if (validateDateOrder &&
            date &&
            isDateBefore(date, validateDateOrder)) {
            setError('End date is before start date.');
        }
        else if (date && isEndOfDayBeforeNow(date, 'MM/DD/YYYY')) {
            setError('Date is in the past.');
        }
        else {
            setFieldValue(valuesField, date);
            setError('');
        }
    };
    return (React.createElement(InputContainer, { size: "large" },
        React.createElement(InlineChildren, { size: InlineChildren.Sizes.Large },
            React.createElement(DateField, { autoComplete: "off", label: "Start date", onBlur: function () {
                    isValidDate('budgetActiveDate', setHasActiveDateError, values.budgetActiveDate);
                }, onChange: handleChange('budgetActiveDate'), value: values.budgetActiveDate || '', placeholder: 'MM/DD/YYYY', error: hasActiveDateError || errors.budgetActiveDate, isDisabled: disableStartDate, "data-anchor-id": "budgetActiveDate" }),
            React.createElement(DateField, { autoComplete: "off", label: "End date", isRequired: values.budgetRefreshInterval === BUDGET_REFRESH_INTERVAL.OneTime, onChange: handleChange('budgetInactiveDate'), onBlur: function () {
                    isValidDate('budgetInactiveDate', setHasInactiveDateError, values.budgetInactiveDate, values.budgetActiveDate);
                }, value: values.budgetInactiveDate || '', placeholder: 'MM/DD/YYYY', error: hasInactiveDateError || errors.budgetInactiveDate, "data-anchor-id": "budgetInactiveDate" }))));
};
export default BudgetDatesSelector;
